module.exports = __webpack_public_path__ + "img/Mitsubishi.4a04ce0e.jpg";